// src/components/admin/Customers.jsx
import React, { useState, useEffect, useMemo } from 'react';
import './Customers.css';

const SUB_LABELS = { payment_due: 'Payment Due', active: 'Active', grace_period: 'Grace Period', cancelled: 'Cancelled' };
const SUB_CLASSES = { payment_due: 'cust-pill-pending', active: 'cust-pill-active', grace_period: 'cust-pill-grace', cancelled: 'cust-pill-gray' };

const STORE_LABELS = {
  not_created: 'Not Created', waiting_for_content: 'Waiting for Content',
  in_progress: 'In Progress', ready_for_review: 'Ready for Review', created: 'Live',
};
const STORE_CLASSES = {
  not_created: 'cust-pill-gray', waiting_for_content: 'cust-pill-pending',
  in_progress: 'cust-pill-progress', ready_for_review: 'cust-pill-active', created: 'cust-pill-active',
};

const Customers = () => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchCustomers = async () => {
    try {
      setLoading(true);
      const res = await fetch('https://creativepulse.pk/main-api/get-customers.php');
      const data = await res.json();
      if (data.success) setCustomers(data.customers);
    } catch (e) {
      console.error('Error fetching customers:', e);
    } finally {
      setLoading(false);
    }
  };

  const filtered = useMemo(() => {
    const term = searchTerm.trim().toLowerCase();
    if (!term) return customers;
    return customers.filter(c =>
      (c.lead_name || '').toLowerCase().includes(term) ||
      (c.business_name || '').toLowerCase().includes(term) ||
      (c.domain_name || '').toLowerCase().includes(term)
    );
  }, [customers, searchTerm]);

  const formatMoney = (n) => n ? `PKR ${Number(n).toLocaleString()}` : '—';
  const formatDate = (d) => d ? new Date(d).toLocaleDateString() : '—';

  return (
    <div className="customers-page">
      <div className="customers-header">
        <div>
          <h1>Customers</h1>
          <p>Leads that have converted into paying, active customers.</p>
        </div>
      </div>

      <div className="customers-filter-bar">
        <input
          type="text"
          className="customers-search"
          placeholder="Search name, store, or domain..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {loading ? (
        <div className="customers-loading">Loading...</div>
      ) : filtered.length === 0 ? (
        <div className="customers-empty">
          No customers yet — convert a lead by setting its status to "Converted to Customer" on the Leads page.
        </div>
      ) : (
        <div className="customers-table-container">
          <table className="customers-table">
            <thead>
              <tr>
                <th>Client</th>
                <th>Store</th>
                <th>Domain</th>
                <th>Plan</th>
                <th>Monthly</th>
                <th>Payment</th>
                <th>Store Status</th>
                <th>Content</th>
                <th>Converted</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(c => (
                <tr key={c.id}>
                  <td className="cust-client-name">{c.lead_name}</td>
                  <td>{c.business_name || '—'}</td>
                  <td className="cust-muted">{c.domain_name || '—'}</td>
                  <td>{c.plan_name || '—'}</td>
                  <td>{formatMoney(c.monthly_amount)}</td>
                  <td>
                    {c.subscription_id ? (
                      <span className={`cust-pill ${SUB_CLASSES[c.subscription_status] || ''}`}>
                        {SUB_LABELS[c.subscription_status] || c.subscription_status}
                      </span>
                    ) : (
                      <span className="cust-pill cust-pill-gray">No Subscription</span>
                    )}
                  </td>
                  <td>
                    <span className={`cust-pill ${STORE_CLASSES[c.store_status] || 'cust-pill-gray'}`}>
                      {STORE_LABELS[c.store_status] || c.store_status}
                    </span>
                  </td>
                  <td className="cust-muted">
                    {c.content_submission_id ? (c.content_status || '—') : 'Not submitted'}
                  </td>
                  <td className="cust-muted">{formatDate(c.converted_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Customers;